'use strict'
import Helper from '@/utils/helper'

class FileInfo {
  constructor ({ extension, length, path, sha256Hash }) {
    Helper.checkString('FileInfo.extension', extension)
    Helper.checkInt('FileInfo.length', length)
    Helper.checkString('FileInfo.path', path)
    Helper.checkString('FileInfo.sha256Hash', sha256Hash)

    this.extension = extension
    this.length = length
    this.path = path
    this.sha256Hash = sha256Hash
  }

  getExtension () {
    return this.extension
  }

  getLength () {
    return this.length
  }

  getPath () {
    return this.path
  }

  getSha256Hash () {
    return this.sha256Hash
  }

  isVideoType (types = ['mp4', 'webm', 'mpeg']) {
    return types.includes(this.extension.toLowerCase())
  }

  isPictureType (types = ['jpg', 'jpeg', 'png', 'svg', 'gif']) {
    return types.includes(this.extension.toLowerCase())
  }
}

export default FileInfo
